export default __webpack_public_path__ + "static/media/goopter-no-download-instant-ordering.4f391f3f.png";